import { Field } from "formik";
import classNames from "classnames";
import { EMPTY_STRING, CLOUD_SERVICES } from "../../../../constants";

const SetAppDetail = ({
  values,
  handleBlur,
  handleChange,
  touched,
  errors,
}) => {
  return (
    <div className="scrollbar flex-1 overflow-auto">
      <div className="space-y-4 p-6 border-b border-gray-700 form-group">
        <div>
          <label className="text-sm font-medium text-gray-50 mb-1 block">
            Application Name <span className="text-red-600 text-m mt-2">*</span>
          </label>
          <Field
            type="text"
            className={classNames("form-control border-2", {
              "border-red-600": touched.name && errors.name,
            })}
            placeholder="Application Name"
            name="name"
            value={values.name}
            onChange={handleChange}
            onBlur={handleBlur}
            autoFocus
          />
          {touched.name && errors.name && (
            <div className="font-medium text-red-500 text-sm">
              {errors.name}
            </div>
          )}
        </div>
        <div className="form-group">
          <label className="text-sm font-medium text-gray-50 mb-1 block">
            Cloud Service
            <span className="text-red-600 text-m mt-2">*</span>
          </label>
          <Field
            as="select"
            name="cloudService"
            className={classNames("form-control border-2", {
              "border-red-600": touched.cloudService && errors.cloudService,
            })}
          >
            <option value={EMPTY_STRING} hidden>Select Service</option>
            {CLOUD_SERVICES.map((each) => (
              <option value={each.value} key={each.name}>
                {each.name}
              </option>
            ))}
          </Field>
          {touched.cloudService && errors.cloudService && (
            <div className="text-sm font-medium text-red-500">
              {errors.cloudService}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SetAppDetail;
